// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel {
    static getAttributeTypeMap() {
        return ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel.attributeTypeMap;
    }
}
ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel.discriminator = undefined;
ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel.additionalProperties = false;
ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=scriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel.js.map